module.exports = __webpack_public_path__ + "static/media/img-f3b8fb2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/canyon-logo.png
// module id = 5281
// module chunks = 39